var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-menu g3" }, [
    _c("ul", [
      _c("li", { staticClass: "head" }, [_vm._v("Account")]),
      _vm._v(" "),
      _c(
        "li",
        [_c("router-link", { attrs: { to: "/account" } }, [_vm._v("Profile")])],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        [
          _c("router-link", { attrs: { to: "/account/password" } }, [
            _vm._v("Password"),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }